export default "__VITE_ASSET__CeYnon9A__"